import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { DeleteEntitiesUseCaseInterface } from 'domain/usecases';

export class RemoteDeleteEntities implements DeleteEntitiesUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<DeleteEntitiesUseCaseInterface.Result>,
  ) {}

  async execute(
    params: DeleteEntitiesUseCaseInterface.Params,
  ): Promise<DeleteEntitiesUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'delete',
      url: this.url + '/' + params.id,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
